export const ACTION_TYPES = {
    trackPpsChange: '@@search/tracking/TRACK_PPS_CHANGE',
    trackPpsFocus: '@@search/tracking/TRACK_PPS_FOCUS',
    trackPpsSelect: '@@search/tracking/TRACK_PPS_SELECT',
};

export const TRACKING_CONSTANTS = {
    patientPoweredSearch: 'PatientPoweredSearch',
    patientPoweredSearchSearchField: 'SearchField',
    patientPoweredSearchSearchQuery: 'SearchQuery',
    patientPoweredSearchSearchAutocompleteTerm: 'SearchAutocompleteTerm',
    user: 'user',
    type: 'type',
    click: 'click',
    searchBar: 'SearchBar',
};
